import _indexOf from './_indexOf.js';

export default function _includes(a, list) {
  return _indexOf(list, a, 0) >= 0;
}


//////////////////
// WEBPACK FOOTER
// /opt/mybespokeroom/shared/~/ramda/es/internal/_includes.js
// module id = 81
// module chunks = 0 1 2 3 4 5 6 8